export default __webpack_public_path__ + "static/media/meter.cc1bbb07.jpg";